import { Controller } from "@hotwired/stimulus"

// 「代表者と同じ」チェックボックスの制御
// 新規登録時: チェック時は取引責任者フィールドを非表示にし、代表者情報をコピー
// 編集時: チェック時は代表者情報をコピー表示（readonly）
export class SameAsRepresentativeController extends Controller {
  static targets = ["checkbox", "transactionKanji", "transactionKana", "fieldContainer",
                    "representativeKanji", "representativeKana"]
  static values = { editMode: Boolean }

  connect() {
    this.toggle()
  }

  toggle() {
    const isChecked = this.checkboxTarget.checked

    if (this.editModeValue) {
      this.toggleEditMode(isChecked)
    } else {
      this.toggleNewMode(isChecked)
    }
  }

  // 代表者情報を取引責任者フィールドにコピー
  copyRepresentativeToTransaction() {
    this.transactionKanjiTarget.value = this.representativeKanjiTarget.value
    this.transactionKanaTarget.value = this.representativeKanaTarget.value
  }

  // 新規登録時の動作
  toggleNewMode(isChecked) {
    this.fieldContainerTargets.forEach(container => {
      container.style.display = isChecked ? "none" : ""
    })

    if (isChecked) {
      // 代表者情報をコピー（非表示だがフォーム送信時に値が送られる）
      this.copyRepresentativeToTransaction()
    }
  }

  // 編集時の動作
  toggleEditMode(isChecked) {
    if (isChecked) {
      this.copyRepresentativeToTransaction()
      this.transactionKanjiTarget.readOnly = true
      this.transactionKanaTarget.readOnly = true
    } else {
      this.transactionKanjiTarget.readOnly = false
      this.transactionKanaTarget.readOnly = false
    }
  }

  // 取引責任者フィールドをクリア
  clear() {
    this.transactionKanjiTarget.value = ""
    this.transactionKanaTarget.value = ""
    this.checkboxTarget.checked = false

    // 新規登録時はフィールドを表示
    if (!this.editModeValue) {
      this.fieldContainerTargets.forEach(container => {
        container.style.display = ""
      })
    }

    // 編集時はreadonlyを解除
    if (this.editModeValue) {
      this.transactionKanjiTarget.readOnly = false
      this.transactionKanaTarget.readOnly = false
    }
  }
}
